import type { Props } from './Svg'
import { Svg } from './Svg'

export function CrossMediumIcon(props: Props) {
  return (
    <Svg width="14" height="14" fill="none" stroke="var(--text)" {...props}>
      <path d="M13 13 1 1m0 12L13 1" />
    </Svg>
  )
}
